/** @jsxImportSource react */

import Avatar from '@react/shared/components/Avatar';
import { Link } from '@react/system';
import { Agent } from '@sly/core/types';

interface AgentInfoProps {
  agent: Agent;
  nameText: string;
  subText: string;
}

const AgentInfo = ({ agent, nameText, subText }: AgentInfoProps) => {
  return (
    <div className='my-6 flex flex-row gap-4'>
      <div className='h-12 w-12'>
        <Avatar
          name={agent?.name || ''}
          path={agent?.gallery?.images[0]?.path}
        />
      </div>

      <div>
        <Link className='text-black underline' href={agent?.info?.url}>
          {nameText}
        </Link>
        <div className='font-b-s text-slate-lighter-40'>{subText}</div>
      </div>
    </div>
  );
};

export default AgentInfo;
